import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

type DropdownItemProps = {
  custom?: boolean;
  separated?: boolean;
  muted?: boolean;
  selected?: boolean;
  external?: boolean;
  link?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownItem',
  props: {
    custom: { type: Boolean, default: false },
    separated: { type: Boolean, default: false },
    muted: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    external: { type: Boolean, default: false },
    link: { default: '' }
  },
  setup(__props: any) {

const props = __props as { custom: boolean, separated: boolean, muted: boolean, selected: boolean, external: boolean, link: string };



const className = computed(() => {
  return {
    'dropdown-item': true,
    'dropdown-item--default': !props.custom,
    'dropdown-item--separated': props.separated,
    'dropdown-item--selected': props.selected,
    'dropdown-item--muted': props.muted,
  };
});
const type = computed(() => (props.link ? (props.external ? 'a' : 'NuxtLink') : 'div'));

/**
 * Links starts from http is automatically external, but
 * we still have a case when link should be outside vue-router
 */
const isExternal = computed(() => {
  if (typeof props.link === 'string') {
    return props.link?.match(/^https?:\/\//) || props.external;
  }
  return props.external;
});

const rootProps = computed(() => {
  if (props.link && isExternal.value) return { href: props.link };
  if (props.link) return { to: props.link };

  return {};
});

return { __sfc: true,props, className, type, isExternal, rootProps }
}

})